export enum ConditionalStatusRelations {
  conditionalStatusGroup = 'conditionalStatusGroup',
}
